import styled from "styled-components"

import {greys, perkbox} from "@irati/ui/src/global/colors"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {H4} from "@irati/ui/src/Headings"

export const Flex = styled.div`
  max-width: 400px;
  margin: 0 auto;
  ${minWidthMedia.tablet`
    width: auto;
    max-width: 800px;
    display: flex;
  `}
`

export const CodeWrapper = styled.div`
  text-align: center;
`

export const Code = styled.div`
  background-color: ${perkbox.greenBlue};
  color: ${greys.white};
  display: inline-block;
  padding: 20px 30px;
  margin-bottom: 30px;
  border-radius: 3px;
  position: relative;
`

export const AppScreenImg = styled.img`
  display: none;
  height: 442px;
  width: auto;
  position: relative;
  left: 80px;
  ${minWidthMedia.tablet`
    display: block;
  `}
`

export const Description = styled(H4)`
  margin: 0 auto 30px;
  text-align: center;
`

export const TextMeInstructionsWrapper = styled.div`
  margin-top: 30px;
`

export const TooltipAttach = styled.div`
  position: absolute;
  right: -20px;
  top: -15px;
`
